<template>
	<div class="warp">
		<div class="login">
			<div class="login-card">
				<h2 style="text-align: center;">
					<p style="border-bottom: 2px solid #0052D9;display: inline-block;line-height: 50px;">重置密码</p>
				</h2>

				<div style="padding: 40px;box-sizing: border-box;">

					<el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm" label-width="100px"
					
						class="demo-ruleForm">
						<el-form-item label="手机号" prop="phone"  style="margin-bottom:40px;">
							<el-input v-model="ruleForm.phone" placeholder="请输入您的手机号"></el-input>
						</el-form-item>
						<el-form-item label="新密码:" prop="pass" style="margin-bottom: 20px;">
							<el-input v-model="ruleForm.pass" type="password" placeholder="6-16位密码，区分大小写">
							</el-input>

							<div class="intensity" >
								<span class="line" :class="[level.includes('low') ? 'low' : '']"></span>
								<span class="line" :class="[level.includes('middle') ? 'middle' : '']"></span>
								<span class="line" :class="[level.includes('high') ? 'high' : '']"></span>
								<span class="psdText">密码强度: <span style="color: #0052D9;">{{pwdStrength}}</span></span>
							</div>
						</el-form-item>
						<el-form-item label="确认密码:" prop="checkPass">
							<el-input  v-model="ruleForm.checkPass"  type="password" placeholder="确认密码">
									</el-input>
									<div class="intensity" >
										<span class="line" :class="[level.includes('low') ? 'low' : '']"></span>
										<span class="line" :class="[level.includes('middle') ? 'middle' : '']"></span>
										<span class="line" :class="[level.includes('high') ? 'high' : '']"></span>
										<span class="psdText">密码强度: <span style="color: #0052D9;">{{pwdStrength}}</span></span>
									</div>
						</el-form-item>

						<el-form-item label="验证码" prop="code">
							<div style="display: flex;">
								<el-input v-model="ruleForm.code" style="flex: 1;" placeholder="请输入验证码"></el-input>
								<div class="inp-yz" :class="{grey:isGrey,blue:!isGrey}" :disabled="dis"
									@click="getCode">
									<span v-if="show">发送验证码</span>
									<span v-else>重新发送({{count}}s)</span>
								</div>
							</div>
						</el-form-item>
						<div class="btns">
							<div class="btn-f" @click="$router.go(-1)">
								返回
							</div>
							<div class="btn-t" @click="submitForm('ruleForm')">
								提交
							</div>
						</div>
					</el-form>
				</div>

			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {

			var checkPhone = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('手机号不能为空'));
				}
				setTimeout(() => {
						if (value.toString().length !== 11) {
							callback(new Error('手机号需为11位'));
						} else {
							callback();
						}
				}, 500);
			};
			var checkCode = (rule, value, callback) => {
				if (!value) {
					return callback(new Error('验证码不能为空'));
				} else {
					callback();
				}
			};
			return {
				dis: false,
				show: true,
				isGrey: false, //按钮样式
				timer: null, //设置计时器,
				count: "",
				xyRadio: false,
				registerType: 'phone',
				pwdStrength:'',
				ruleForm: {
					pass: '',
					checkPass: '',
					code: '',
					phone: ''
				},
				level: [],
				rules: {
					phone: [{
						validator: checkPhone,
						trigger: 'blur'
					}],

					pass: [{
						required: true,
						validator: this.checkPassword,
						trigger: 'change'
					}],
					checkPass: [{
						required: true,
						validator: this.checkConfirmPassword,
						trigger: 'change'
					}],

					code: [{
						validator: checkCode,
						trigger: 'blur'
					}]
				}
			};
		},
		methods: {
			    // 校验密码
			    checkPassword(rule, value, callback) {
			      this.level = []
			      if (!value) {
			        return callback('密码不能为空')
			      }
			      if (value.length < 6) {
			        return callback('密码不少于6位')
			      }
			      if (value.length > 16) {
			        return callback('密码不大于16位')
			      }
			      // 校验是数字
			      const regex1 = /^\d+$/
			      // 校验字母
			      const regex2 = /^[A-Za-z]+$/
			      // 校验符号
			      const regex3 =
			        /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、]+$/
			      if (regex1.test(value)) {
			        this.level.push('low')
					this.pwdStrength = '弱'
			      } else if (regex2.test(value)) {
			        this.level.push('low')
					this.pwdStrength = '弱'
			      } else if (regex3.test(value)) {
			        this.level.push('low')
					this.pwdStrength = '弱'
			      } else if (/^[A-Za-z\d]+$/.test(value)) {
			        this.level.push('low')
			        this.level.push('middle')
					this.pwdStrength = '中'
			      } else if (
			        /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、\d]+$/.test(
			          value
			        )
			      ) {
			        this.level.push('low')
			        this.level.push('middle')
					this.pwdStrength = '中'
			      } else if (
			        /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z]+$/.test(
			          value
			        )
			      ) {
			        this.level.push('low')
			        this.level.push('middle')
					this.pwdStrength = '中'
			      } else if (
			        /^[`~!@#$%^&*()_\-+=<>?:"{}|,.\/;'\\[\]·~！@#￥%……&*（）——\-+={}|《》？：“”【】、；‘'，。、A-Za-z\d]+$/.test(
			          value
			        )
			      ) {
			        this.level.push('low')
			        this.level.push('middle')
			        this.level.push('high')
					this.pwdStrength = '强'
			      }
			       callback()
			    },
			    // 确认密码
			    checkConfirmPassword(rule, value, callback) {
			      if (!value) {
			         callback('请输入确认密码')
			      }
			      if (value != this.ruleForm.pass) {
			         callback('两次密码输入不一致，请重新输入')
			      }else{
					  callback()
				  }
				  
			    },
		async getCode() {
			let TIME_COUNT = 60;
			const phoneRegex = /^1\d{10}$/;
			if (phoneRegex.test(this.ruleForm.phone)) {
				if (!this.timer) {
					this.count = TIME_COUNT;
					this.isGrey = true;
					this.show = false;
					this.dis = true;
					const yzcode = await this.$api.sendPhoneCode({
						mobile: this.ruleForm.phone
					})
					console.log(yzcode.code);
					if (yzcode.code == 1) {
						this.$message({
							message:yzcode.msg,
							type: 'success'
						});
						this.timer = setInterval(() => {
							if (this.count > 0 && this.count <= TIME_COUNT) {
								this.count--;
							} else {
								this.dis = false;
								this.isGrey = false;
								this.show = true;
								clearInterval(this.timer);
								this.timer = null;
							}
						}, 1000);
					} else {
						this.$message({
							message: yzcode.msg,
							type: 'warning'
						});
					}
				}
			} else {
				this.$message.error('手机号格式错误');
			}
		
		},
			submitForm(formName) {
				console.log(this.$refs[formName].validate());
				this.$refs[formName].validate(async (valid) => {
					console.log(valid,123213);
					if (valid) {
						console.log(1111);
							const reSet =await this.$api.resetpwd({
								mobile:this.ruleForm.phone,
								captcha:this.ruleForm.code,
								newpassword:this.ruleForm.pass
							})
							if(reSet.code == 1){
								this.$message({
									message:reSet.msg,
									type: 'success'
								});
								this.$router.replace('/login')
							}else{
								this.$message({
									message:reSet.msg,
									type: 'warning'
								});
							}
						
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
		}
	}
</script>

<style scoped>
.show_pwd {
  cursor: pointer;
  user-select: none;
  padding-right: 5px;
}
.intensity {
	display: flex;
	align-items: center;
	justify-content: space-between;
	height: 30px;
  .psdText {
    font-size: 14px;
    margin-right: 10px;
  }
  .line {
    display: inline-block;
    width: 48px;
    height: 4px;
    background: #d8d8d8;
    border-radius: 3px;
    margin-right: 8px;
    &.low {
      background: #0052D9;
    }
    &.middle {
      background: #0052D9;
    }
    &.high {
      background: #0052D9;
    }
  }
  .level {
    margin: 0 16px 0 8px;
  }
  .warningtext {
    color: #5a5a5a;
    font-size: 12px;
    margin-top: 5px;
  }
}
	.btns {
		margin-top: 50px;
		display: flex;
		align-items: center;
		justify-content: space-between;
	}

	.btns>.btn-t {
		background: #0052D9;
		color: white;
	}

	.btns>div {
		cursor: pointer;
		text-align: center;
		line-height: 45px;
		width: 160px;
		height: 45px;
		color: #0052D9;
		border: 1px solid #0052D9;
	}

	.el-input__inner {
		background-color: #F6F6F6 !important;

	}

	.inp-yz {
		cursor: pointer;
		width: 100px;
		height: 40px;
		background: #E5EDFB;
		margin-left: 8px;
		color: #0052D9;
		line-height: 40px;
		text-align: center;
	}

	


	.login {
		padding-top: 80px;
	}

	.login-card>h2 {
		border-bottom: 1px solid #E5E5E5;

	}

	.login-card {
		position: relative;
		margin: 0 auto;
		box-sizing: border-box;
		padding-top: 20px;
		width: 480px;
		background: #FFFFFF;
		border: 1px solid #E7E7E7;
		box-shadow: 0px 3px 16px 0px rgba(0, 0, 0, 0.16);
		border-radius: 5px;
	}

	.warp {
		background: url('../../assets/images/loginBG.png') no-repeat;
		background-size: cover;
		width: 100%;
		height: 870px;
	}
</style>